<template>
	<g :transform="'translate(' + x + ',' + y + ')'">
		<rect class="backRect" :x="x + depthOffset.x - x" :y="y - depthOffset.y - y" :width="width" :height="height" />
		
		<g :transform="'translate(3, -32)'">
			<g v-for="(p, index) in parts" :key="index" :transform="'translate(' + (index * (width/parts - (!isFirst ? -2 : 0)) ) + ', 0)'">
				<path d="M54.4936 0.048584H53.605L1.77686 30.9999H2.66552L54.4936 0.048584Z" fill="#EBECEC"/>
				<path fill-rule="evenodd" clip-rule="evenodd" d="M6.21712 30.9649C5.03985 30.9649 3.86257 30.9649 2.6853 30.9649L54.4853 0C55.6625 0 56.8398 0 58.0171 0L6.21712 30.9649Z" fill="#C5C6C6"/>
				<path d="M58.9365 0.048584H58.0479L6.21973 30.9999H7.10839L58.9365 0.048584Z" fill="#B2B3B3"/>
				<path d="M93.7168 0.048584H92.8281L41 30.9999H41.8887L93.7168 0.048584Z" fill="#EBECEC"/>
				<path fill-rule="evenodd" clip-rule="evenodd" d="M45.4885 30.9649C44.3112 30.9649 43.0434 30.9649 41.8661 30.9649L93.7566 0C94.9339 0 96.1112 0 97.2884 0L45.4885 30.9649Z" fill="#C5C6C6"/>
				<path d="M98.1599 0.048584H97.2712L45.4431 30.9999H46.3318L98.1599 0.048584Z" fill="#B2B3B3"/>
				<path d="M68.3064 0.048584H67.4177L15.5896 30.9999H16.4783L68.3064 0.048584Z" fill="#EBECEC"/>
				<path d="M68.3058 0.048584H69.1945L17.3663 30.9999H16.4777L68.3058 0.048584Z" fill="#FEFEFE"/>
				<path d="M69.1952 0.048584H70.0839L18.2557 30.9999H17.3671L69.1952 0.048584Z" fill="#C5C6C6"/>
				<path d="M70.9725 0.048584H70.0839L18.2557 30.9999H19.1444L70.9725 0.048584Z" fill="#D9DADA"/>
				<path d="M81.1312 0.048584H80.2426L28.4144 30.9999H29.3031L81.1312 0.048584Z" fill="#EBECEC"/>
				<path d="M81.1314 0.048584H82.02L30.1919 30.9999H29.3032L81.1314 0.048584Z" fill="#FEFEFE"/>
				<path d="M82.0199 0.048584H82.9086L31.0805 30.9999H30.1918L82.0199 0.048584Z" fill="#C5C6C6"/>
				<path d="M83.7972 0.048584H82.9086L31.0805 30.9999H31.9691L83.7972 0.048584Z" fill="#D9DADA"/>
				<path d="M10.5095 25.1108L11.2125 24.5979L59 24.5979L58.2971 25.1108L10.5095 25.1108Z" fill="#EBECEC"/>
				<path d="M9.80678 25.6234L10.5098 25.1105L58.2973 25.1105L57.5943 25.6234L9.80678 25.6234Z" fill="#FEFEFE"/>
				<path d="M9.80711 25.6233L9.10413 26.1362L56.8916 26.1362L57.5946 25.6233L9.80711 25.6233Z" fill="#C5C6C6"/>
				<path d="M8.40114 26.6491L9.10413 26.1362L56.8916 26.1362L56.1887 26.6491L8.40114 26.6491Z" fill="#D9DADA"/>
				<path d="M19.1249 19.7193L19.8335 19.2064L67.9999 19.2064L67.2913 19.7193L19.1249 19.7193Z" fill="#EBECEC"/>
				<path d="M18.4169 20.232L19.1255 19.7191L67.2918 19.7191L66.5833 20.232L18.4169 20.232Z" fill="#FEFEFE"/>
				<path d="M18.4172 20.2322L17.7086 20.7451L65.875 20.7451L66.5835 20.2322L18.4172 20.2322Z" fill="#C5C6C6"/>
				<path d="M17.0001 21.258L17.7086 20.7451L65.875 20.7451L65.1664 21.258L17.0001 21.258Z" fill="#D9DADA"/>
				<path d="M28.1251 14.3282L28.8336 13.8153L77.0001 13.8153L76.2915 14.3282L28.1251 14.3282Z" fill="#EBECEC"/>
				<path d="M27.4169 14.8408L28.1255 14.3279L76.2919 14.3279L75.5834 14.8408L27.4169 14.8408Z" fill="#FEFEFE"/>
				<path d="M27.4172 14.8409L26.7086 15.3538L74.8751 15.3538L75.5836 14.8409L27.4172 14.8409Z" fill="#C5C6C6"/>
				<path d="M26.0001 15.8666L26.7086 15.3538L74.8751 15.3538L74.1665 15.8666L26.0001 15.8666Z" fill="#D9DADA"/>
				<path d="M38.0834 8.93683L38.7781 8.42395L86.0001 8.42395L85.3054 8.93683L38.0834 8.93683Z" fill="#EBECEC"/>
				<path d="M37.3892 9.44965L38.0839 8.93677L85.3058 8.93677L84.6112 9.44965L37.3892 9.44965Z" fill="#FEFEFE"/>
				<path d="M37.3894 9.4494L36.6947 9.96228L83.9167 9.96228L84.6114 9.4494L37.3894 9.4494Z" fill="#C5C6C6"/>
				<path d="M36 10.4752L36.6947 9.96228L83.9167 9.96228L83.222 10.4752L36 10.4752Z" fill="#D9DADA"/>
				<path d="M47.0835 3.60932L47.7782 3.09644L95.0001 3.09644L94.3054 3.60932L47.0835 3.60932Z" fill="#EBECEC"/>
				<path d="M46.3891 4.12201L47.0837 3.60913L94.3056 3.60913L93.611 4.12201L46.3891 4.12201Z" fill="#FEFEFE"/>
				<path d="M46.3894 4.122L45.6947 4.63489L92.9166 4.63489L93.6112 4.122L46.3894 4.122Z" fill="#C5C6C6"/>
				<path d="M45 5.14777L45.6947 4.63489L92.9166 4.63489L92.2219 5.14777L45 5.14777Z" fill="#D9DADA"/>
				<path d="M98.6963 0.048584H97.8076L45.9795 30.9999H46.8682L98.6963 0.048584Z" fill="#EBECEC"/>
				<path d="M98.6961 0.048584H99.5847L47.7566 30.9999H46.8679L98.6961 0.048584Z" fill="#FEFEFE"/>
				<path d="M99.5841 0.048584H100.473L48.6447 30.9999H47.756L99.5841 0.048584Z" fill="#C5C6C6"/>
				<path d="M101.361 0.048584H100.473L48.6447 30.9999H49.5333L101.361 0.048584Z" fill="#D9DADA"/>
				<path d="M52.7168 0.048584H51.8281L7.44977e-06 30.9999H0.88866L52.7168 0.048584Z" fill="#EBECEC"/>
				<path d="M52.7162 0.048584H53.6049L1.77674 30.9999H0.888089L52.7162 0.048584Z" fill="#FEFEFE"/>
				<path d="M53.6048 0.048584H54.4934L2.66529 30.9999H1.77664L53.6048 0.048584Z" fill="#C5C6C6"/>
				<path d="M55.3821 0.048584H54.4934L2.66529 30.9999H3.55394L55.3821 0.048584Z" fill="#D9DADA"/>
			</g>
		</g>

		<polygon class="topEdge" :points="topEdgeBack" />
		<polygon class="topEdge" :points="topEdgeFront" />

		<line class="topLine" v-for="line in topLines" :x1="line.x1" :y1="line.y1" :x2="line.x2" :y2="line.y2" />
		<rect class="deepRect" :x="x - x" :y="y + 2.3 - y" :width="width" :height="6.3" />
		<rect class="frontRect" :x="x - x" :y="y - y" :width="width" :height="height" />

		<rect class="bottomEdge" :x="x - x" :y="y + 2 - y" :width="width" :height="0.3" />
		<rect class="topEdge" :x="x - x" :y="y + 8 - y" :width="width" :height="1" />
	</g>
</template>

<script>
	export default {
		name: 'ShelfGrid1000',
		props: {
			x: Number,
			y: Number,
			width: Number,
			height: {
				type: Number,
				default: 11,
			},
			parts: {
				type: Number,
				default: 6,
			},
			rackOffset: Object,
			depthOffset: Object,
			isFirst: Boolean,
		},
		computed: {
			topLines() {
				const lines = [];
				const partWidth = this.width / this.parts;

				for (let i = 1; i < this.parts; i++) {
					lines.push({
						x1: 0 + partWidth * i,
						y1: 0,
						x2: 0 + this.depthOffset.x + partWidth * i,
						y2: 0 - this.depthOffset.y,
					});
				}

				return lines;
			},
			topEdgeBack() {
				return `${0 + this.depthOffset.x},${0 - this.depthOffset.y}
						${0 + this.width + this.depthOffset.x},${0 - this.depthOffset.y}
						${0 + this.width + this.depthOffset.x - this.rackOffset.x / 2},${0 - this.depthOffset.y + this.rackOffset.y / 2}
						${0 + this.depthOffset.x - this.rackOffset.x / 2},${0 - this.depthOffset.y + this.rackOffset.y / 2}`;
			},
			topEdgeFront() {
				return `0,0
						${0 + this.width},0
						${0 + this.width + this.rackOffset.x / 2},${0 - this.rackOffset.y / 2}
						${0 + this.rackOffset.x / 2},${0 - this.rackOffset.y / 2}`;
			},
		},
	};
</script>

<style scoped>
	.topPolygon {
		fill: #DCDDDE;
	}
	.rightPolygon {
		fill: #C4C6C8;
	}
	.frontRect {
		fill:#DCDDDE;
	}
	.backRect {
		fill:#9FA1A4;
	}
	.topEdge {
		fill: #EFEFF0;
	}
	.topLine {
		stroke: #BABCBE;
		stroke-width: 0.4;
	}
	.bottomEdge {
		fill: #AFB1B4;
	}
	.deepRect {
		fill: #D6D6D6;
	}
	.deepPolygon {
		fill: #B8B8B8;
	}
</style>